import { render } from "./news.vue?vue&type=template&id=cb84bfc6&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=cb84bfc6&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb84bfc6"]])

export default __exports__